// src/pages/playlists/SaveToPlaylistButton.jsx
// The handoff's list-plus button for existing screens. Shows list-check in
// orange when the lecture is in any playlist. Owns its sheet and toast.
// variant="text" adds a label ("Save to playlist" / "Saved · <playlist>"),
// used under the play button on the lecture page.
import { useState } from "react";
import { PlsIc } from "./playlistIcons";
import { useMyPlaylists } from "./playlistsStore";
import { usePlaylistToast } from "./usePlaylistToast";
import SaveToPlaylistSheet from "./SaveToPlaylistSheet";
import "./playlists.css";

export default function SaveToPlaylistButton({ itemKey, title, kind = "audio", large = false, variant = "icon", className = "" }) {
  const { playlists } = useMyPlaylists();
  const [open, setOpen] = useState(false);
  const [toastNode, toast] = usePlaylistToast();
  const ins = playlists.filter((p) => p.items.includes(itemKey));
  const saved = ins.length > 0;
  const text = variant === "text";

  return (
    <>
      <button
        type="button"
        className={`${text ? "pls-savelink" : "pls-savebtn"} ${saved ? "is-saved" : ""} ${large ? "is-lg" : ""} ${className}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
        aria-label={saved ? "Saved. Edit playlists" : "Save to playlist"}
        title={saved ? "Edit playlists" : "Save to playlist"}
      >
        {PlsIc.save(text ? 18 : 19, saved)}
        {text &&
          (saved ? (
            <span className="label">
              Saved<span className="sub"> · {ins.length === 1 ? ins[0].name : `${ins.length} playlists`}</span>
            </span>
          ) : (
            <span className="label">Save to playlist</span>
          ))}
      </button>
      {open && (
        <SaveToPlaylistSheet itemKey={itemKey} title={title} kind={kind}
          onClose={(msg) => { setOpen(false); if (msg) toast(msg); }} />
      )}
      {toastNode}
    </>
  );
}
